import { createBrowserRouter, redirect, useNavigate } from "react-router-dom";
import { AuthLayout, MainLayout } from "../Layout";
import {
  Home,
  NotFound,
  ProjectDetail,
  Projects,
  Gallery,
} from "../Pages/Main";

const router = createBrowserRouter([
  {
    path: "",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "projects",
        element: <Projects />,
      },
      {
        path: "gallery",
        element: <Gallery />,
      },
      {
        path: "projects/details/:code",
        element: <ProjectDetail />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
export default router;
